import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import {
  ChatMessage,
  CursorQuery,
  Namespace,
} from '@wix/ambassador-legends-persona-v1-chat/types';
import { queryChatMessages } from '@wix/ambassador-legends-persona-v1-chat/http';

import { request } from '../../../../services/request';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';

export default async function (
  flowAPI: ControllerFlowAPI,
  chatId: string,
  store: any,
): Promise<ChatMessage[]> {
  const messages = (await queryAllChatMessages(flowAPI, chatId))?.toReversed();

  if (store.currentChatId !== chatId) {
    return messages;
  }

  store.messages = [...messages];

  flowAPI.controllerConfig.setProps({
    messages,
  });

  return messages;
}

// TODO: implement infinity scroll instead of fetching all messages at once
async function queryAllChatMessages(
  flowAPI: ControllerFlowAPI,
  chatId: string,
): Promise<ChatMessage[]> {
  let messages = [];
  let hasNext = false;
  let next: string | null = null;

  do {
    try {
      const query: CursorQuery = {
        cursorPaging: {
          limit: 100,
          cursor: next,
        },
      };

      const getChatMessagesTransaction =
        flowAPI.panoramaClient.transaction('get-chat-messages');

      getChatMessagesTransaction.start();

      const response = await request({
        flowAPI,
        options: queryChatMessages({
          chatId,
          namespace: Namespace.EDUCATION,
          query,
        }),
        errorOptions: {
          errorCodesMap: { applicationError: {} },
        },
      });

      messages = [...messages, ...(response.data.chatMessages || [])];

      hasNext = response.data.pagingMetadata?.hasNext;
      next = response.data.pagingMetadata?.cursors?.next;

      getChatMessagesTransaction.finish();
    } catch (error) {
      const resolvedError = flowAPI.errorHandler.getResolvedError(error);

      handleError({
        error,
        resolvedError,
        context: 'GetChatMessages',
        preventErrorMonitorReport: !shouldReportErrorMonitor(error),
      });

      hasNext = false;
      next = null;
    }
  } while (hasNext);

  return messages;
}
